import React from "react";
import { AiOutlineClose } from "react-icons/ai";

// Баруунаас гарч ирэх профайл/цэсний хавтас + арын бүдэг давхарга
function BurgerMenu({ showMenu, children, onClose }) {
  return (
    <>
      <div
        onClick={onClose}
        className={`fixed inset-0 z-[99] bg-black/30 transition-opacity duration-200 ${
          showMenu ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />
      <div
        className={`fixed w-[300px] max-w-[85vw] z-[100] inset-y-0 right-0 bg-white shadow-menuShadow transition-transform ease-out duration-200 overflow-y-auto ${
          showMenu ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ paddingTop: "var(--safe-top)" }}
      >
        <div className="py-3 flex justify-end px-4">
          <button className="p-2 rounded-full text-gray-500 hover:bg-gray-100 transition-colors" onClick={onClose}>
            <AiOutlineClose size={22} />
          </button>
        </div>
        {children}
      </div>
    </>
  );
}

export default BurgerMenu;
